import request from '@/plugins/request'

export function getWeiBoNews(skey, symd, eymd, pageindex, pagesize) {
    return request({
        url: '/v1/News/GetWeiBoNews',
        method: 'post',
        data: {
            skey: skey,
            startYmd: symd,
            endYmd: eymd,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function getDouYinNews(skey, symd, eymd, pageindex, pagesize) {
    return request({
        url: '/v1/News/GetDouYinNews',
        method: 'post',
        data: {
            skey: skey,
            startYmd: symd,
            endYmd: eymd,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function getTouTiaoNews(skey, symd, eymd, pageindex, pagesize) {
    return request({
        url: '/v1/News/GetTouTiaoNews',
        method: 'post',
        data: {
            skey: skey,
            startYmd: symd,
            endYmd: eymd,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function getBaiDuNews(skey, symd, eymd, pageindex, pagesize) {
    return request({
        url: '/v1/News/GetBaiDuNews',
        method: 'post',
        data: {
            skey: skey,
            startYmd: symd,
            endYmd: eymd,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function getTengXunNews(skey, symd, eymd, pageindex, pagesize) {
    return request({
        url: '/v1/News/GetTengXunNews',
        method: 'post',
        data: {
            skey: skey,
            startYmd: symd,
            endYmd: eymd,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}